import {Route, Routes} from 'react-router-dom';
import Admin from "./pages/Admin";
import Booking from "./pages/Booking";
import {useEffect} from "react";
import {fetchThemeFromServer} from "./utils/themeManager";

function App() {
    useEffect(() => {
        fetchThemeFromServer();
    }, []);

    return (
        <Routes>
            <Route
                path="/"
                element={<Booking />}
            />
            <Route
                path="/admin"
                element={<Admin/>}
            />
            <Route
                path="/booking"
                element={<Booking/>}
            />
        </Routes>
    );
}

export default App;
